import { createSelector } from 'reselect';
import { FieldFeature } from '../types';
import { AppState } from '../store/types/Store';

const layersSelector = (state: AppState) => state.layers;
const fieldSelector = (state: AppState) => state.field;
const featureFlagsSelector = (state: AppState) => state.feature.userConfigFeatures;

export const splitViewEnabledSelector = createSelector(
  [layersSelector, fieldSelector, featureFlagsSelector],
  (layers, field) => (!layers.isSplitViewEnabled && field.features.includes(FieldFeature.SPLIT_VIEW))
);

export const isSplitViewEnabledSelector = createSelector(
  [layersSelector, fieldSelector],
  (layers, field) => layers.isSplitViewEnabled && field.features.includes(FieldFeature.SPLIT_VIEW)
);
